module.exports = __webpack_public_path__ + "img/banner-bg-md-2x.9296164.jpg";